import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IpLimitationConfigDTO } from "app/data/schema/Subscription/IpLimitationConfigDTO";
import { ThemeDTO } from "app/data/schema/Subscription/ThemeDTO";
import { TimeLimitationConfigDTO } from "app/data/schema/Subscription/TimeLimitationConfigDTO";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { ContractDTO } from "../../schema/Subscription/ContractDTO";
import { FacebookPixelDTO } from "../../schema/Subscription/FacebookPixelDTO";
import { FooterDataDTO } from "../../schema/Subscription/FooterDataDTO";
import { GoogleAdWordsDTO } from "../../schema/Subscription/GoogleAdWordsDTO";
import { GoogleAnalyticsDTO } from "../../schema/Subscription/GoogleAnalyticsDTO";
import { GoogleTagManagerDTO } from "../../schema/Subscription/GoogleTagManagerDTO";
import { HubSpotDTO } from "../../schema/Subscription/HubSpotDTO";
import { InitialRegistrationSettingsDTO } from "../../schema/Subscription/InitialRegistrationSettingsDTO";
import { LanguageDTO } from "../../schema/Subscription/LanguageDTO";
import { LoginApiRestSettingsDTO } from "../../schema/Subscription/LoginApiRestSettingsDTO";
import { LoginSettings } from "../../schema/Subscription/LoginSettings";
import { RDStationDTO } from "../../schema/Subscription/RDStationDTO";
import { SubscriptionDTO } from "../../schema/Subscription/SubscriptionDTO";
import { SubscriptionInsertDTO } from "../../schema/Subscription/SubscriptionInsertDTO";

@Injectable({
    providedIn: "root"
})
export class ApiSubscriptionsService {
    constructor(private http: HttpClient) {}

    create(subscriptionDTO: SubscriptionInsertDTO): Observable<SubscriptionDTO> {
        return this.http.post<SubscriptionDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions`,
            JSON.stringify(subscriptionDTO),
            {
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            }
        );
    }

    get(
        disabled = false,
        find = "",
        orderBy = "nome",
        sortOrder = "asc",
        skip = 0,
        take = 10,
        onlyIds = []
    ): Observable<GetDataDTO<SubscriptionDTO>> {
        let params: HttpParams = new HttpParams()
            .set("disabled", disabled.toString())
            .set("skip", skip.toString())
            .set("take", take.toString())
            .set("sortOrder", sortOrder.toString())
            .set("find", find)
            .set("orderBy", orderBy);

        if (onlyIds) {
            onlyIds.forEach((value) => {
                params = params.append("onlyIds", value);
            });
        }

        return this.http.get<GetDataDTO<SubscriptionDTO>>(`${environment.subscription.url}/api/v1/Susbcriptions`, {
            params: params
        });
    }

    getById(id: string): Observable<SubscriptionDTO> {
        return this.http.get<SubscriptionDTO>(`${environment.subscription.url}/api/v1/Susbcriptions/${id}`);
    }

    public GetSubscriptionByHost(host: string): Observable<SubscriptionDTO> {
        return this.http.get<SubscriptionDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions/Public?host=${host}`
        );
    }

    getUserAllowedRoles(): Observable<string[]> {
        return this.http.get<string[]>(`${environment.subscription.url}/api/v1/Susbcriptions/userAllowedRoles`);
    }

    update(id: string, subscriptionDTO: SubscriptionDTO): Observable<SubscriptionDTO> {
        return this.http.put<SubscriptionDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions/${id}`,
            subscriptionDTO
        );
    }

    updateFooter(id: string, footerDataDTO: FooterDataDTO): Observable<SubscriptionDTO> {
        return this.http.patch<SubscriptionDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions/${id}/footer`,
            footerDataDTO
        );
    }

    getAll(): Observable<SubscriptionDTO[]> {
        return this.http.get<SubscriptionDTO[]>(`${environment.subscription.url}/api/v1/Susbcriptions/getall`);
    }

    privacyPolicy(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/privacy-policy`, formData);
    }

    UploadBanner(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/banner`, formData);
    }

    UploadBannerLogin(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/bannerLogin`, formData);
    }

    UploadPrimaryLogo(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/primary-logo`, formData);
    }

    UploadSecundaryLogo(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/secundary-logo`, formData);
    }

    UploadPoweredByLogo(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/powered-by-logo`, formData);
    }

    UploadAdminLogo(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/admin-logo`, formData);
    }

    UploadFavIcon(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/fav-icon`, formData);
    }

    UploadShareImage(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/share-image`, formData);
    }

    UploadAppIcon(id: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", file);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/app-icon`, formData);
    }

    termsOfUse(id: string, termsOfUse: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", termsOfUse);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/terms-of-use`, formData);
    }

    termsOfPurchase(id: string, termsOfPurchase: File): Observable<any> {
        const formData = new FormData();
        formData.append("formFile", termsOfPurchase);
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/terms-of-purchase`, formData);
    }

    UploadFacebookPixel(id: string, pixel: FacebookPixelDTO): Observable<any> {
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/facebookPixel`, pixel);
    }

    UpdateGoogleAnalytics(id: string, googleAnalytics: GoogleAnalyticsDTO): Observable<any> {
        return this.http.post(
            `${environment.subscription.url}/api/v1/Susbcriptions/${id}/googleAnalytics`,
            googleAnalytics
        );
    }

    UploadGoogleTagManager(id: string, googleTagManagerDTO: GoogleTagManagerDTO): Observable<any> {
        return this.http.post(
            `${environment.subscription.url}/api/v1/Susbcriptions/${id}/googleTagManagerDTO`,
            googleTagManagerDTO
        );
    }

    UpdateGoogleAdWords(id: string, googleAdWords: GoogleAdWordsDTO): Observable<any> {
        return this.http.post(
            `${environment.subscription.url}/api/v1/Susbcriptions/${id}/googleAdWords`,
            googleAdWords
        );
    }

    UpdateRDStation(id: string, rdstation: RDStationDTO): Observable<any> {
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/rdstation`, rdstation);
    }

    UpdateHubSpot(id: string, hubSpot: HubSpotDTO): Observable<any> {
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/hubSpot`, hubSpot);
    }

    RequesDataReview(id: string): Observable<any> {
        return this.http.post(`${environment.subscription.url}/api/v1/Susbcriptions/${id}/requestDataReview`, null);
    }

    UpdateSubscriptionData(subscription: SubscriptionDTO): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscription.id}/subscriptionData`,
            subscription
        );
    }

    UpdateSubscriptionTheme(subscriptionId: string, theme: ThemeDTO): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/subscriptionTheme`,
            theme
        );
    }

    UpdateLoginSettings(subscriptionId: string, loginSettings: LoginSettings): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/loginSettings`,
            loginSettings
        );
    }

    UpdateIpLimitation(subscriptionId: string, ipLimitationConfig: IpLimitationConfigDTO[]): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/loginSettings/access-limitation-config/ip-limitation-config`,
            ipLimitationConfig
        );
    }

    UpdateTimelimitation(subscriptionId: string, timeLimitationConfig: TimeLimitationConfigDTO[]): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/loginSettings/access-limitation-config/time-limitation-config`,
            timeLimitationConfig
        );
    }

    UpdateApiRestSettings(subscriptionId: string, settings: LoginApiRestSettingsDTO): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/loginSettings/apiRestSettings`,
            settings
        );
    }

    GetLoginsApiRestSettings(subscriptionId: string): Observable<LoginApiRestSettingsDTO> {
        return this.http.get<LoginApiRestSettingsDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/loginSettings/apiRestSettings`
        );
    }

    UpdateSubscriptionContract(subscriptionId: string, contract: ContractDTO): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/contract`,
            contract
        );
    }

    GetPrivacyPolicyTemplate(subscriptionId: string): Observable<string> {
        return this.http.get(`${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/privacy-policy`, {
            responseType: "text"
        });
    }

    SetPrivacyPolicyTemplate(subscriptionId: string, template: string): Observable<any> {
        return this.http.post(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/privacy-policy`,
            JSON.stringify(template),
            {
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            }
        );
    }

    GetTermsOfUseTemplate(subscriptionId: string): Observable<string> {
        return this.http.get(`${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/terms-of-use`, {
            responseType: "text"
        });
    }

    SetTermsOfUseTemplate(subscriptionId: string, template: string): Observable<any> {
        return this.http.post(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/terms-of-use`,
            JSON.stringify(template),
            {
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            }
        );
    }

    GetTermsOfPurchaseTemplate(subscriptionId: string): Observable<string> {
        return this.http.get(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/terms-of-purchase`,
            {
                responseType: "text"
            }
        );
    }

    SetTermsOfPurchaseTemplate(subscriptionId: string, template: string): Observable<any> {
        return this.http.post(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/terms-of-purchase`,
            JSON.stringify(template),
            {
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                }
            }
        );
    }

    updateCoursesCatalogFile(subscriptionId: string, file: File): Observable<SubscriptionDTO> {
        const formData = new FormData();
        formData.append("formFile", file);

        return this.http.patch<SubscriptionDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/coursesCatalog/file`,
            formData
        );
    }

    updateCoursesCatalogUrl(subscriptionId: string, url: string): Observable<SubscriptionDTO> {
        return this.http.patch<SubscriptionDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/coursesCatalog/url`,
            {
                url: url
            }
        );
    }

    deleteCoursesCatalogUrl(subscriptionId: string): Observable<SubscriptionDTO> {
        return this.http.delete<SubscriptionDTO>(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/coursesCatalog/url`
        );
    }

    updateInitialRegistrationSettings(
        subscriptionId: string,
        settings: InitialRegistrationSettingsDTO
    ): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/initial-registration-settings`,
            settings
        );
    }

    updateDefaultLanguage(subscriptionId: string, language: LanguageDTO): Observable<any> {
        return this.http.patch(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/defaultLanguage`,
            { DefaultLanguage: language }
        );
    }

    saveRequestNewSsoCustomToken(subscriptionId: string): Observable<any> {
        return this.http.post(
            `${environment.subscription.url}/api/v1/Susbcriptions/${subscriptionId}/request-sso-custom-token`,
            null
        );
    }
}
